import { render, staticRenderFns } from "./relatoriosHome.vue?vue&type=template&id=62260961&"
import script from "./relatoriosHome.vue?vue&type=script&lang=js&"
export * from "./relatoriosHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports